import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Errors, UserService} from '../../core';

@Component({
    selector: 'app-auth-page',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
    authType: String = '';
    title = '';
    errors: Errors = {errors: {}};
    isSubmitting = false;
    authForm: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private fb: FormBuilder,
    ) {
        // use FormBuilder to create a form group
        this.authForm = this.fb.group({
            'email': ['', Validators.required],
            'password': ['', Validators.required]
        });
    }

    ngOnInit() {
    }

    submitForm() {
        this.isSubmitting = true;
        this.errors = {errors: {}};

        const credentials = this.authForm.value;

        this.userService
            .attemptAuth(credentials)
            .subscribe(
                data => {
                  document.location.replace('/settings');
                },
                err => {
                    this.errors = {errors: {password: err.message}};
                    this.isSubmitting = false;
                }
            );
    }

    getError(name) {
        return this.errors.errors[name] ? this.errors.errors[name] : '';
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/auth.component.ts